import Button from "@mui/material/Button";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { router } from "../router";

interface ViewProfileSnackbarActionProps {
	to: string;
	onNavigate?: () => void;
}

const ViewProfileSnackbarAction: FC<ViewProfileSnackbarActionProps> = ({ to, onNavigate }) => {
	const { t } = useTranslation();

	const handleClick = () => {
		router.navigate(to);
		onNavigate?.();
	};

	return (
		<Button
			data-testid="snackbar-view-profile-action"
			size="small"
			onClick={handleClick}
			sx={{
				color: "inherit",
				textTransform: "none",
				fontWeight: 600,
				"&:hover": { textDecoration: "underline", backgroundColor: "transparent" },
			}}
		>
			{t("snackbar.action.viewProfile")}
		</Button>
	);
};

export default ViewProfileSnackbarAction;
